import { getGridItemIndex } from '../shared';
import getLayoutItem from './layoutItem';

const GridItem = getLayoutItem('rowIndex', (section, itemProps, cols) => {
  let result = null;

  if (section.isRowItem) {
    //only render row item once
    if (itemProps.columnIndex === 0) {
      result = {
        index: 0,
        itemProps: {
          ...itemProps,
          style: { ...itemProps.style, width: '100%' },
        },
      };
    }
  } else {
    const itemIndex = getGridItemIndex(itemProps.columnIndex, itemProps.rowIndex, cols);
    result = { index: itemIndex };
  }

  return result;
});

export default GridItem;
